import React, { Component } from 'react'
import Alert  from './../Alert';
import {getAllUrlParams} from "./../UrlParameters"
import { RestUrls } from "../Urls";

/* https://github.com/axios/axios */


function checkPageName(props) {
    
    //console.log(props);

    if(props.results.center) {
        return 'שטחי מסחר';
    }
    else if (props.results.pageData.page.title) {
        return props.results.pageData.page.title
    }
    else return 'צור קשר כללי';
}

function SendAklead(props) {
    
    let data = props.results.data;

    //console.log(data);
    
        if(data.name) {
        

        const axios = require('axios').default; /* npm install axios */
        const Getpath = RestUrls.Leads; // 'https://www.avisror.com/appi/welcome/leadform';
        //const Getpath = 'https://www.avisror.com/appi/welcome/leadform?code=' + RestUrls.Code2;

        
        let siteId = 'avisror';

        let centerProjId = data.centerProjId ? data.centerProjId : '';

        const urlQuery = getAllUrlParams(localStorage.getItem('path_' + siteId));

        console.log('urlQuery', urlQuery);

        //const pageLink = urlQuery ? JSON.stringify(urlQuery) : '';

        const campaign_id = urlQuery.campaign_id ? urlQuery.campaign_id : '';

        //const pageName = checkPageName(props.results.pageData.page.title ? props.results.pageData.page.title : 'צור קשר כללי';

        const pageName = checkPageName(props);

        const utm = {

            utm_content : urlQuery.utm_content ? urlQuery.utm_content : '',
            utm_medium :  urlQuery.utm_medium ?  urlQuery.utm_medium : '',
            utm_source :  urlQuery.utm_source ? urlQuery.utm_source : '',
            utm_term :  urlQuery.utm_term ?  urlQuery.utm_term : '',
            utm_campaign : urlQuery.utm_campaign ?  urlQuery.utm_campaign : ''

        }

        //console.log('utm', utm);

        //&utm_source=rehovot&utm_medium=431&utm_content=content&utm_term=term&utm_campaign=camp

        const Params = 
            '?name=' + data.name +
            '&phone=' + data.phone +
            '&email=' + data.email +
            
            '&utm_content=' + utm.utm_content +
            '&utm_medium='  + utm.utm_medium +
            '&utm_source='  + utm.utm_source +
            '&utm_term='  + utm.utm_term +
            '&utm_campaign='  + utm.utm_campaign +

            '&itkunim=0' +
            '&custom2=site' +
            '&bannerid=' + props.results.infoSite.media +
            '&message=' +
            '&page=' + pageName +
            '&campaign_id=' + campaign_id +
            '&projId=' + data.projId +
            '&centerProjId=' + centerProjId +
            '&analytics=analytics' +
            '&catName=catName' +
            '&catValue=catValue' +
            '&code=' + RestUrls.Code2 + 
            '&page_link=' + localStorage.getItem('path_' + siteId);


        const  fullPath = Getpath + Params;

        //console.log('Params', Params);

        localStorage.setItem('lidResponse', false);

        axios.get(fullPath)

            .then(function (response) {
                window.location.hash = 'thanks';
            })

            .catch(function (error) {
                localStorage.setItem('lidResponse', 'error');
                window.location.reload(true);
            });

        return true 
    }

    else {
        return <h2>No Name</h2>
    }
       
}



export default class SendLead extends Component {

    

    formatValue = (data) => Array.isArray(data) 
        ? data.join(", ") : data.toString();
    
    render() {

        //console.log(localStorage.getItem('lidResponse'));

        let keys = Object.keys(this.props.data);
        if (keys.length === 0) {
            if(localStorage.getItem('lidResponse')==='error') {
                return <Alert title='שגיאה' message='הפרטים לא נשלחו' show={true} error={true}/>
            }
            else {
                return false
            }
        } else {
            return <SendAklead results={this.props} />
            
            
        }

    }
}
